<template>
  <footer class="mt-footer">
    © {{ new Date().getFullYear() }} Polymorphic Tech Ltd · All Rights Reserved
  </footer>
</template>
